/**
 * 模块名称: 厂商Id查询
 * @author zhuyan@372163.com
 */

import React, { useState, useEffect, useRef } from 'react'
import api from '@/api'
import {
  Table,
  Button,
  message,
} from 'antd'

const { Column } = Table

let filter = {
  name: '',
}

const VendorIdQuery = (props) => {
  const { setVendorVisible, setVendorLoading } = props
  const [vendorList, setVendorList] = useState([])

  useEffect(() => {
    filter = {
      name: '',
    }
    // getVendorList()
  }, [])


  const getVendorList = () => {
    setVendorLoading(true)
    api.getVendorList({ vendor: filter.name })
      .then(data => {
        setVendorLoading(false)
        setVendorList(data.list)
      })
      .catch(() => setVendorLoading(false))
  }

  const departInp = useRef(null)
  const onSearch = () => {
    filter.name = departInp.current.value
    if (departInp.current.value == '') {
      message.info("请输入厂商ID")
      return
    }
    getVendorList()
  }

  const onKeyup = (e) => {
    if (e.keyCode === 13) {
      onSearch()
    }
  }

  return (
    <>
      <div className="vendorstry">
        <div className="vendorwrap">
          <div className="vendor-item">
            <div style={{ width: 80 }}>厂商ID: </div>
            <input className="ant-input" ref={departInp} type="text" placeholder="请输入厂商ID " onKeyUp={onKeyup} />
          </div>
          <Button onClick={onSearch} type="primary">查询</Button>
        </div>
        <Table
          dataSource={vendorList}
          rowKey="id"
          className="table-page"
          pagination={false}
        >
          <Column title="项目" dataIndex="projectName" />
          <Column title="产品" dataIndex="productName" />
          <Column title="厂商ID" dataIndex="vendor" />
          <Column title="客户名称" dataIndex="client" />
          <Column title="OAID" dataIndex="clientId" />
          <Column title="关联代理商" dataIndex="agentName" />
          <Column title="代理商ID" dataIndex="agentId"  render={(text, record) => <div>{text == 0 ? '' : text}</div>}/>
          <Column title="所属销售" dataIndex="relSalerName" />
          <Column title="所属客服" dataIndex="relServicerName" />
          <Column title="代理商负责人" dataIndex="relAgentStaffName" />
        </Table>

        <div style={{ height: 60 }}></div>
        <div className="setVendorstryBtn">
          <Button type="primary" onClick={() => { setVendorVisible(false) }}>关闭</Button>
        </div>
      </div>
    </>
  )
}

export default VendorIdQuery